module.exports = __webpack_public_path__ + "img/stock0.642a03c9.png";